import {Component} from "react";

// API Endpoints
import * as api from "../../api/api";

// Json Feeds
import SiteConfig from "../../api/site-config.json";
// import SiteConfig from "./site-config_mixed.json"; # test data with variations of site types

// Images and Assets
import flowWorksLogo from "./flowworks-logo@0.75x.png"
import MapImage from "./assets/MapImage.jpg";
import LegendImage from "./assets/Legend.jpg";

// Primary Components
import SiteContainer from "../site/site-component";
import SiteLine from "../site-path/site-path-component";

// Site Type components
import Rainfall from "../site/rainfall/rainfall-component";
import PipeLevel from "../site/pipeLevel/pipeLevel-component";
import Overflow from "../site/overflow/overflow-component";
import TidalGauge from "../site/tidalGauge/tidalGauge-component";

// Styles
import "./styles/app-styles.scss"

export default class extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            mapImageLoaded: false,
            mapImageWidth: false,
            mapImageHeight: false,
            siteDataLoading: false,
            siteDataError: false,
            siteDataErrorMessage: null,
            siteData: {},
        };

        this.loadDataPromised = this.loadDataPromised.bind(this);
        this.getData = this.getData.bind(this);

        let refreshDataInterval = setInterval(()=>{
            this.getData();
        }, 60000);
    }

    showCoordinates(e) {
        let mapBackgroundClientRect = document.getElementById("map-background").getClientRects();
        let mapBackgroundClientRectTop = mapBackgroundClientRect[0].top;
        let mapBackgroundClientRectLeft = mapBackgroundClientRect[0].left;

        let mouseX = e.clientX;
        let mouseY = e.clientY;

        const currentX = mouseX - mapBackgroundClientRectLeft;
        const currentY = mouseY - mapBackgroundClientRectTop;

        console.log(`
            Co-ordinates
            ============
            X: ${ currentX }px
            Y: ${ currentY }px
        `);
    }

    componentWillMount() {

        let getMapImageDimensions = new Image();
        getMapImageDimensions.onload = (image) => {
            this.setState({
                mapImageWidth: image.srcElement.width,
                mapImageHeight: image.srcElement.height,
                mapImageLoaded: true
            });
        };
        getMapImageDimensions.src = MapImage;
    }

    loadDataPromised(apiSiteId, apiPast1hrRainfallChannelName, apiPast24hrRainfallChannelName, apiRainfallChannelName) {

        return new Promise((resolve, reject) => {

            api.fetchRainfallScreenData(apiSiteId, apiPast1hrRainfallChannelName, apiPast24hrRainfallChannelName, apiRainfallChannelName).then(
                response => {
                    // console.log("SUCCESS");
                    resolve(response.data);
                },
                error => {
                    console.log("ERROR:");
                    reject(error);
                }
            );
        });
    };

    getData(){
        let loadSitesPromisesArray = [];

        // loadDataPromised() returns a promise. So let's store each site into an array
        SiteConfig.map((currentSite) => {

            // skip the globalSettings object since we only care about sites
            if (!currentSite.globalSettings) {
                loadSitesPromisesArray.push(
                    this.loadDataPromised(currentSite.siteId,
                        currentSite.past1hrRainfall.rainfallChannel,
                        currentSite.past24hrRainfall.rainfallChannel,
                        currentSite.rawRainfallChannel)
                );
            }
        });
        // console.log(loadSitesPromisesArray);

        // using that promise array we can create one response when they are all resolved, or a catch if any one has been rejected
        Promise.all(loadSitesPromisesArray).then((response) => {

            // If all promises are resolved we'll return an object containing the resolved responses!
            response.forEach((site) => {
                this.setState({
                    [`siteData${site.siteId}`]: site
                })
            });

            this.setState({
                siteDataLoading: false
            });

        }).catch((error) => {
            // but if ANY promise returns a rejection then no resolved promises will this return. Only this ONE error, even if multiple promises returned reject
            console.log(error);
            this.setState({
                siteDataError: true,
                siteDataErrorMessage: error.toString()
            })
        });
    }


    componentDidMount() {

        this.setState({
            siteDataLoading: true
        });

        this.getData();
    }


    render() {

        const {mapImageWidth, mapImageHeight} = this.state;

        if (!this.state.mapImageLoaded) {
            return (
                <div className="alert alert-info">
                    <strong><i className="fa fa-spin fa-spinner"></i> Loading Map.</strong> Please wait &hellip;
                </div>
            )
        }

        if (this.state.siteDataError){
            return (
                <div className="alert alert-danger">
                    <p><strong><i className="fa fa-exclamation-circle"></i> Error.</strong> There was an error fetching the Data. Please check your network connection and refresh the page. If problems persist please contact FlowWorks Support.</p>
                    { ( this.state.siteDataErrorMessage ) &&
                    <p><em>{this.state.siteDataErrorMessage}</em></p>
                    }
                </div>
            )
        }

        if (this.state.siteDataLoading) {
            return (
                <div className="alert alert-info">
                    <strong><i className="fa fa-spin fa-spinner"></i> Loading Rainfall Data.</strong> Please wait &hellip;
                </div>
            )
        }

        return (
            <div className="wrapper">
                <div id="map-background" onClick={this.showCoordinates} className="map-background"
                     style={{
                         backgroundImage: "linear-gradient(rgba(255, 255, 255, " + SiteConfig[0].globalSettings.mapWhiteOverlayIntensity + "),rgba(255, 255, 255, " + SiteConfig[0].globalSettings.mapWhiteOverlayIntensity + ")), url(" + MapImage + ")",
                         width: mapImageWidth,
                         height: mapImageHeight
                     }}>

                    <svg className="site-paths" width={ mapImageWidth} height={mapImageHeight}>
                        <defs>
                            <marker id='arrowHead' orient='auto' markerWidth='10' markerHeight='10'
                                    refX='3' refY='3'>
                                <path d='M0,0 L0,6 L5,3 Z' fill='#ff7300'/>
                            </marker>
                            <marker id='arrowHeadForIcon' orient='auto' markerWidth='10' markerHeight='10'
                                    refX='10.5' refY='3'>
                                <path d='M0,0 L0,6 L5,3 Z' fill='#ff7300'/>
                            </marker>
                        </defs>

                        {
                            SiteConfig.map((currentSiteConfig, index) => {

                                if (currentSiteConfig.globalSettings) {
                                    return;
                                }

                                // Validation for Positioning
                                if (![1, 2].includes(currentSiteConfig.startPositionColumn)) {
                                    console.log(`Error Drawing Line: Object Site ID:${currentSiteConfig.siteId} has unknown value for the property startPositionColumn: ${currentSiteConfig.startPositionColumn} in SiteConfig json array. Please choose 1 or 2.`);
                                    return;
                                }
                                if (![1, 2, 3, 4, 5, 6].includes(currentSiteConfig.startPositionRow)) {
                                    console.log(`Error Drawing Line: Object Site ID:${currentSiteConfig.siteId} has unknown value for the property startPositionRow: ${currentSiteConfig.startPositionRow} in SiteConfig json array. Please choose a number between 1-6.`);
                                    return;
                                }

                                return (
                                    <SiteLine key={index}
                                              siteId={currentSiteConfig.siteId}
                                              siteType={currentSiteConfig.siteType}
                                              mapImageWidth={mapImageWidth}
                                              startPositionColumn={currentSiteConfig.startPositionColumn}
                                              startPositionRow={currentSiteConfig.startPositionRow}
                                              endLineX={currentSiteConfig.endLineX}
                                              endLineY={currentSiteConfig.endLineY}
                                              showIcon={currentSiteConfig.showIcon}/>
                                );
                            })
                        }
                    </svg>

                    <div className="site-containers">
                        {
                            SiteConfig.map((currentSiteConfig, index) => {

                                if (currentSiteConfig.globalSettings) {
                                    return;
                                }

                                // Validation for Positioning
                                if (![1, 2].includes(currentSiteConfig.startPositionColumn)) {
                                    console.log(`Error Drawing Line: Object Site ID:${currentSiteConfig.siteId} has unknown value for the property startPositionColumn: ${currentSiteConfig.startPositionColumn} in SiteConfig json array. Please choose 1 or 2.`);
                                    return;
                                }
                                if (![1, 2, 3, 4, 5, 6].includes(currentSiteConfig.startPositionRow)) {
                                    console.log(`Error Drawing Line: Object Site ID:${currentSiteConfig.siteId} has unknown value for the property startPositionRow: ${currentSiteConfig.startPositionRow} in SiteConfig json array. Please choose a number between 1-6.`);
                                    return;
                                }

                                // let currentSiteData = this.state.siteData.filter((data) => data.siteId === currentSiteConfig.siteId); # old way

                                // we need to join two arrays using the siteId as a primary key.
                                const stateKey = "siteData" + currentSiteConfig.siteId;

                                let currentSiteData = this.state[stateKey];

                                // only continue if there was a response
                                if (currentSiteData) {
                                    switch (currentSiteConfig.siteType) {
                                        // Rainfall Site
                                        case 1:
                                            return (
                                                <SiteContainer key={index}
                                                               siteId={currentSiteData.siteId}
                                                               siteType={currentSiteConfig.siteType}
                                                               siteName={currentSiteConfig.siteName}
                                                               positionColumn={ currentSiteConfig.startPositionColumn }
                                                               positionRow={ currentSiteConfig.startPositionRow }
                                                               lastUpdated={currentSiteData.lastUpdated}
                                                               siteOwner={currentSiteConfig.siteOwner} >
                                                    <Rainfall rainfallPast1hrRainfallScaleMax={currentSiteConfig.past1hrRainfall.scaleMax}
                                                              rainfallPast1hrRainfallScaleMin={currentSiteConfig.past1hrRainfall.scaleMin}
                                                              rainfallPast1hrRainfallScaleVal={currentSiteData.past1hrRainfall}
                                                              rainfallPast24hrRainfallScaleMax={currentSiteConfig.past24hrRainfall.scaleMax}
                                                              rainfallPast24hrRainfallScaleMin={currentSiteConfig.past24hrRainfall.scaleMin}
                                                              rainfallPast24hrRainfallScaleVal={currentSiteData.past24hrRainfall}
                                                              rainfallThisMonthURL={currentSiteData.rainfallThisMonthURL}
                                                              rainfallLastMonthURL={currentSiteData.rainfallLastMonthURL}/>
                                                </SiteContainer>
                                            );

                                        // Pipe Level Site
                                        case 2:
                                            return (
                                                <SiteContainer key={index}
                                                               siteId={currentSiteData.siteId}
                                                               siteType={currentSiteConfig.siteType}
                                                               siteName={currentSiteConfig.siteName}
                                                               positionColumn={ currentSiteConfig.startPositionColumn }
                                                               positionRow={ currentSiteConfig.startPositionRow }
                                                               lastUpdated={currentSiteData.lastUpdated}
                                                >
                                                    <PipeLevel pipeLevelCurrentVal={currentSiteData.pipeLevelCurrentVal}
                                                               pipeLevelWarningRangeMedium={currentSiteConfig.pipeLevelWarningRangeMedium}
                                                               pipeLevelWarningRangeHigh={currentSiteConfig.pipeLevelWarningRangeHigh}
                                                               pipeLevelDiameter={currentSiteConfig.pipeDiameter}/>
                                                </SiteContainer>
                                            );

                                        // Overflow Site
                                        case 3:
                                            return (
                                                <SiteContainer key={index}
                                                               siteId={currentSiteData.siteId}
                                                               siteType={currentSiteConfig.siteType}
                                                               siteName={currentSiteConfig.siteName}
                                                               positionColumn={ currentSiteConfig.startPositionColumn }
                                                               positionRow={ currentSiteConfig.startPositionRow }
                                                               lastUpdated={currentSiteData.lastUpdated}
                                                >
                                                    <Overflow overflowPipeLevelCurrentVal={currentSiteData.pipeLevelCurrentVal}
                                                              overflowPast24hrRainfall={currentSiteData.past24hrRainfall}
                                                              overflowStartDate={currentSiteData.overflowStartDate}
                                                              overflowEndDate={currentSiteData.overflowEndDate}
                                                              overflowPipeDiameter={currentSiteConfig.pipeDiameter}/>
                                                </SiteContainer>
                                            );

                                        // Tidal Gauge Site
                                        case 4:
                                            return (
                                                <SiteContainer key={index}
                                                               siteId={currentSiteData.siteId}
                                                               siteType={currentSiteConfig.siteType}
                                                               siteName={currentSiteConfig.siteName}
                                                               positionColumn={ currentSiteConfig.startPositionColumn }
                                                               positionRow={ currentSiteConfig.startPositionRow }
                                                               lastUpdated={currentSiteData.lastUpdated}
                                                >
                                                    <TidalGauge tideScaleMax={currentSiteConfig.tide.scaleMax}
                                                                tideScaleMin={currentSiteConfig.tide.scaleMin}
                                                                tideCurrentVal={currentSiteData.tide.currentVal}/>
                                                </SiteContainer>
                                            );

                                        default:
                                            console.log(`Error Setting up Site: Object Site ID:${currentSiteConfig.siteId} has unknown value for the property Site Type:${currentSiteConfig.siteType}.   Expected: 1, 2, 3, or 4.`);
                                    }
                                }
                                else {
                                    console.log(`Error Setting up Site: Cannot find Site Object ID:${currentSiteConfig.siteId}. Make sure the object ID exists in SiteData json array.`);
                                }
                            })
                        }
                        {
                            ( SiteConfig[0].legend ) &&
                            <SiteContainer key="legend"
                                           fullWidth={true}
                                           positionColumn={ SiteConfig[0].legend.startPositionColumn }
                                           positionRow={ SiteConfig[0].legend.startPositionRow }>
                                <div>
                                    <h6 style={{ marginTop: 0, marginBottom: "5px", textTransform: "none"}}>Legend</h6>
                                    <hr style={{ marginTop: 0, marginBottom: 0, borderWidth: 1 }}/>
                                    <img src={LegendImage} className="img-responsive" alt="legend image"/>
                                </div>
                            </SiteContainer>
                        }
                    </div>
                </div>

                <footer>
                    <div className="footer-left">
                        <a href="http://www.flowworks.com/network" target="_blank">
                            <img src={flowWorksLogo} className="flowworks-logo"/>
                        </a>
                    </div>
                    <div className="footer-right">
                        <p>The data and calculations available on this web site are for the exclusive use and
                            benefit of the specific clients whose sites are operated on this server. Although
                            clients may have consented to having their data made publicly available, no other
                            party is entitled to rely on any of the data or any other information contained on or
                            accessible from this web site for conclusions or opinions. Some of the data may be
                            raw or incomplete. No warranty, express or implied, is made.</p>
                        <p className="mb-0">
                            <strong>Learn More:</strong> <a href="http://www.flowworks.com/" target="_blank">www.flowworks.com</a>
                        </p>
                    </div>
                </footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/app/app-component.js